import { createAction, handleActions } from "redux-actions";
import * as ActionTypes from "./actionType";
import { request } from "utils/apiClient/base";

const initialState = {
  data: {},
  error: null
};

export default handleActions(
  {
    [`${ActionTypes.PAGE_INIT}_FULFILLED`]: (state, action) => ({
      ...state,
      data: action.payload
    }),
    [`${ActionTypes.PAGE_INIT}_PENDING`]: () => initialState,
    [`${ActionTypes.PAGE_INIT}_REJECTED`]: (state, action) => ({
      ...state,
      error: action.payload
    }),
    [`${ActionTypes.INDUSTRY_SCALE_GET}_FULFILLED`]: (state, action) => ({
      ...state,
      data: action.payload // data を上書き
    }),
    [`${ActionTypes.INDUSTRY_SCALE_GET}_REJECTED`]: (state, action) => ({
      ...state,
      error: action.payload
    })
  },
  initialState
);

export const actionCreators = {
  initPage: createAction(ActionTypes.PAGE_INIT, params => request(397, params)),
  getIndustryScale: createAction(ActionTypes.INDUSTRY_SCALE_GET, params =>
    request(398, params)
  )
};
